import React, { useState, useEffect, useCallback } from "react";
import {
  FaSearch,
  FaSortUp,
  FaSortDown,
  FaFileExcel,
  FaCheckCircle,
  FaFilePdf
} from "react-icons/fa";
import Skeleton from "react-loading-skeleton";
import Table from "../../components/Table";
import { Form, InputGroup, DropdownButton, Dropdown } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import * as apicall from "../../components/Apicall";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FaBell } from "react-icons/fa";
import "../../App.css";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { MultiSelect } from "primereact/multiselect";
import "primereact/resources/themes/lara-light-pink/theme.css"; // theme
import "primereact/resources/primereact.min.css"; // core css
import "primeicons/primeicons.css"; // icons

const fallbackStatusList = [
  { id: 0, name: "Payment not done" },
  { id: 1, name: "Payment initiated" },
  { id: 2, name: "Pay later initiated - Pending" },
  { id: 3, name: "Pay later successful/received" },
  { id: 4, name: "Paid online" },
  { id: 5, name: "Cash on service" },
  { id: 6, name: "Cash Paid" },
  { id: 7, name: "Paid through link" },
  { id: 8, name: "Pay later amount received" },
  { id: 9, name: "Refund completed" },
  { id: 10, name: "Complimentary order" }
];

const BookingsList = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [bookings, setBookings] = useState([]);
  const [filteredBookings, setFilteredBookings] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [loadingBookings, setLoadingBookings] = useState(true);
  const [statusList, setStatusList] = useState([]);
  const [vendors, setVendors] = useState([]);
  const [allStates, setAllStates] = useState([]);
  const [allCities, setAllCities] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [services, setServices] = useState([]);
  const [searchTerm, setSearchTerm] = useState(
    location.state?.searchTerm || ""
  );
  const [vendorFilter, setVendorFilter] = useState(
    location.state?.vendorFilter || null
  );
  const [stateFilter, setStateFilter] = useState(
    location.state?.stateFilter || null
  );
  const [cityFilter, setCityFilter] = useState(
    location.state?.cityFilter || null
  );
  const [role, setRole] = useState(localStorage.getItem("role"));
  const [oderInfo, setOrderInfo] = useState();
  const [triggerFilterOnClear, setTriggerFilterOnClear] = useState(false);
  const [statusFilter, setStatusFilter] = useState(
    location.state?.statusFilter || []
  );
  const [paymentStatusFilter, setPaymentStatusFilter] = useState(
    location.state?.paymentFilter || []
  );
  const [serviceFilter, setServiceFilter] = useState(
    location.state?.serviceFilter || []
  );
  const [dateFilter, setDateFilter] = useState(
    location.state?.dateFilter || null
  );
  const [filterApplied, setFilterApplied] = useState(
    Boolean(
      location.state?.statusFilter ||
      location.state?.serviceFilter ||
      location.state?.dateFilter ||
      location.state?.paymentFilter ||
      location.state?.vendorFilter ||
      location.state?.stateFilter ||
      location.state?.cityFilter
    )
  );
  const [selectedCardStatus, setSelectedCardStatus] = useState(null);
  const formatDate = (date) => date.toISOString().split("T")[0];
  const [sortDirection, setSortDirection] = useState("asc");
  const [sortColumn, setSortColumn] = useState(null);
  const [sortedBookings, setSortedBookings] = useState([]);
  const [selectedBookings, setSelectedBookings] = useState([]);
  const [invoiceLoadingId, setInvoiceLoadingId] = useState(null);
  const [selectedInvoiceIds, setSelectedInvoiceIds] = useState([]);
  const [bulkInvoiceLoading, setBulkInvoiceLoading] = useState(false);

  const handleCheckboxChange = (booking) => {
    setSelectedBookings((prev) => {
      const exists = prev.find((b) => b.booking_id === booking.booking_id);

      if (exists) {
        return prev.filter((b) => b.booking_id !== booking.booking_id);
      } else {
        return [...prev, booking];
      }
    });
  };
  const handleSort = (column) => {
    if (sortColumn === column) {
      setSortDirection(sortDirection === "asc" ? "desc" : "asc");
    } else {
      setSortColumn(column);
      setSortDirection("asc");
    }
  };
  const exportToExcel = () => {
    if (!sortedBookings.length) {
      toast.info("No data to export!");
      return;
    }

    const exportData = sortedBookings.map((booking) => ({
      "Booking ID": booking.display_booking_id,
      Mode: "Online",
      "First Name": booking.first_name,
      "Last Name": booking.last_name,
      "Phone Number": booking.phone_number,
      "Service Name": booking.service_name,
      "Service Type": booking.service_type_name,
      "Service Offering": booking.service_offering_name,
      "Service Date": new Date(booking.serviceDate).toLocaleDateString(),
      "Service Time": normalizeTimeTo24Hour(booking.service_time),
      "Service Amount": booking.serviceAmount,
      "Payment Status": booking.payment,
      "Vendor Name": booking.vendor_name || "-",
      "Service Status": booking.status,
      "Emriate/City":
        booking.service_details?.service_state ||
        booking.service_details?.to_state ||
        booking.service_state ||
        ""
    }));

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Bookings");

    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array"
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `Bookings_${new Date().toISOString().split("T")[0]}.xlsx`);
  };

  // const checkEzpSyncStatus = async (bookingId) => {
  //   try {
  //     const response = await apicall.get(`checkEzpSyncStatus/${bookingId}`);

  //     return response.data?.length > 0;
  //   } catch (err) {
  //     console.error("EZP status fetch failed", err);
  //     return false;
  //   }
  // };

  const handleSync = async () => {
    if (!selectedBookings.length) {
      toast.warning("Please select at least one booking");
      return;
    }

    try {
      const validBookings = selectedBookings.filter(
        (booking) => booking.vendor_id
      );

      if (!validBookings.length) {
        toast.warning("Selected bookings do not have vendor assigned");
        return;
      }

      await Promise.all(
        validBookings.map((booking) =>
          apicall.post(
            {
              booking_id: booking.booking_id,
              vendor_id: booking.vendor_id
            },
            "/syncToEzeitpro"
          )
        )
      );

      toast.success("Booking synced to Ezeitpro successfully");

      setSelectedBookings([]);

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    } catch (err) {
      console.error("Sync Error:", err);

      toast.error(
        err?.response?.data?.message ||
          "Sync to Ezeitpro failed. Please contact tech support"
      );

      setTimeout(() => {
        window.location.reload();
      }, 1500);
    }
  };
  const today = new Date();
  const defaultStart = new Date(today);
  defaultStart.setDate(today.getDate() - 1);
  const defaultEnd = new Date(today);
  defaultEnd.setDate(today.getDate() + 7);
  const [startDate, setStartDate] = useState(formatDate(defaultStart));
  const [endDate, setEndDate] = useState(formatDate(defaultEnd));
  const ishighlighted = location?.state?.highlightedBookingIds;
  const allowedStatuses = [
    "Vendor Not Assigned",
    "Vendor Assigned",
    "Service Started",
    "Completed",
    "Worker Assigned",
    "Cancelled by User",
    "Cancelled by vendor",
    "Cancelled by Admin"
  ];

  const handleError = (error) => {
    toast.error(error.message.replace("Error:", ""));
  };
  const fetchFilters = useCallback(async () => {
    try {
      const [servicesRes, statusRes, vendorsData, statesRes, citiesRes] =
        await Promise.all([
          apicall.get("services"),
          apicall.get("bookingStatus"),
          apicall.get("vendor_info"),
          apicall.get("states"),
          apicall.get("cities")
        ]);
      setServices(servicesRes.data);
      setStatusList(statusRes.data);
      setVendors(vendorsData.data);
      setAllStates(statesRes.data || []);
      setAllCities(citiesRes.data || []);
    } catch (e) {
      handleError(e);
    }
  }, []);
  const fetchBookings = async (start_date, end_date) => {
    setLoadingBookings(true);
    try {
      const body = {
        start_date: start_date,
        end_date: end_date
      };
      const res = await apicall.post(body, "bookingsList");

      console.log(res, "res");
      if (res.success) {
        const filteredBookings = res.data.filter((booking) =>
          allowedStatuses.includes(booking.status)
        );
        //           const filtered = updatedBookings.filter(booking =>
        //   allowedStatuses.includes(booking.status)
        // );
        // console.log(res.data,"res.data")
        setBookings(res.data);
        setFilteredBookings(filteredBookings);
      } else {
        toast.error(res.message || "Failed to fetch bookings.");
      }
    } catch (e) {
      toast.error(
        e.response?.data?.message ||
          "An error occurred while fetching bookings."
      );
    } finally {
      setLoadingBookings(false);
    }
  };
  const normalizeTimeTo24Hour = (timeStr) => {
    if (!timeStr) return "";

    let formatted = timeStr.replace(".", ":").trim().toUpperCase();

    if (formatted.includes("AM") || formatted.includes("PM")) {
      const [time, modifier] = formatted.split(" ");
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier === "PM" && hours < 12) hours += 12;
      if (modifier === "AM" && hours === 12) hours = 0;

      return `${String(hours).padStart(2, "0")}:${String(minutes || 0).padStart(2, "0")}`;
    }

    let [hour, minute] = formatted.split(":").map(Number);
    if (hour >= 1 && hour < 8) hour += 12;

    return `${String(hour).padStart(2, "0")}:${String(minute || 0).padStart(2, "0")}`;
  };

  const getCity = (booking) =>
    booking?.service_details?.service_state ||
    booking?.service_details?.to_state ||
    booking?.service_state ||
    "";

  // Emirates (Dubai, Abu Dhabi, ...) are stored as "states", same tier as Indian
  // states (Tamil Nadu, ...); cities (Chennai, ...) are a level below those.
  // The backend's /states and /cities already return only the currently
  // operating locations, so just use them as-is here — don't re-narrow by
  // whether the currently selected date range happens to have a booking
  // there, or a location with no bookings yet in view would wrongly vanish.
  const operatingStateOptions = allStates;
  // Cascade: once a state/emirate is picked, only show cities under it.
  const operatingCityOptions = stateFilter?.length
    ? allCities.filter((c) => stateFilter.some((s) => s.id === c.state))
    : allCities;

  // Drop any selected city that no longer belongs to the selected state(s),
  // e.g. switching from Tamil Nadu to Dubai should clear a stale "Chennai" pick.
  useEffect(() => {
    if (!stateFilter?.length) return;
    setCityFilter((prev) =>
      (prev || []).filter((c) => stateFilter.some((s) => s.id === c.state))
    );
  }, [stateFilter]);

  const applyFilters = () => {
    const filtered = bookings.filter((booking) => {
      const matchesService =
        !serviceFilter?.length ||
        serviceFilter.some((service) => service.name === booking.service_name);

      const matchesStatus =
        !statusFilter?.length ||
        statusFilter.some((status) => status.name === booking.status);

      const matchespaymentStatus =
        !paymentStatusFilter?.length ||
        paymentStatusFilter.some((status) => status.name === booking.payment);
      const matchesVendor =
        !vendorFilter?.length ||
        vendorFilter.some((v) =>
          booking.vendor_name
            ?.toLowerCase()
            .includes(v.vendor_name?.toLowerCase())
        );
      const matchesState =
        !stateFilter?.length ||
        stateFilter.some((s) =>
          getCity(booking).toLowerCase().includes(s.name?.toLowerCase())
        );

      const matchesCity =
        !cityFilter?.length ||
        cityFilter.some((c) =>
          getCity(booking).toLowerCase().includes(c.name?.toLowerCase())
        );

      // A booking's location is either a state/emirate or a city, never both, so
      // when both filters have selections, match either rather than requiring both.
      const matchesLocation =
        (!stateFilter?.length && !cityFilter?.length) ||
        (Boolean(stateFilter?.length) && matchesState) ||
        (Boolean(cityFilter?.length) && matchesCity);

      const matchesDate =
        !dateFilter ||
        new Date(booking.serviceDate).toLocaleDateString() ===
          new Date(dateFilter).toLocaleDateString();
      return (
        matchesService &&
        matchesStatus &&
        matchesDate &&
        matchespaymentStatus &&
        matchesVendor &&
        matchesLocation
      );
    });
    setFilteredBookings(filtered);
    setFilterApplied(
      Boolean(
        serviceFilter ||
        statusFilter ||
        dateFilter ||
        paymentStatusFilter ||
        vendorFilter ||
        stateFilter ||
        cityFilter
      )
    );
    setShowFilters(true);
  };

  const clearAllFilters = () => {
    setStatusFilter([]);
    setServiceFilter([]);
    setPaymentStatusFilter([]);
    setVendorFilter([]);
    setStateFilter([]);
    setCityFilter([]);
    setDateFilter(null);
    setVendorFilter([]);
    setCityFilter([]);
    setSearchTerm("");
    setFilterApplied(false);
    setShowFilters(false);
    // setFilteredBookings(bookings);
    const defaultFiltered = bookings.filter((booking) =>
      allowedStatuses.includes(booking.status)
    );
    setFilteredBookings(defaultFiltered);
  };
  const clearAll = () => {
    setStartDate(formatDate(defaultStart));
    setEndDate(formatDate(defaultEnd));
    setTriggerFilterOnClear(true);

    const defaultFiltered = bookings.filter((booking) =>
      allowedStatuses.includes(booking.status)
    );
    setFilteredBookings(defaultFiltered);
  };
  const toggleInvoiceSelection = (bookingId) => {
    setSelectedInvoiceIds((prev) =>
      prev.includes(bookingId)
        ? prev.filter((id) => id !== bookingId)
        : [...prev, bookingId]
    );
  };

  // Fetches the invoice PDFs for the given bookings (generated + uploaded to
  // S3 on first request, then served from bookings.invoice) and saves them.
  const downloadInvoices = async (bookingIds) => {
    const res = await apicall.post(
      { booking_ids: bookingIds },
      "adminBookingInvoice"
    );
    const { files = [], invoices = {}, failed = 0 } = res?.data || {};

    files.forEach((file) => {
      const bytes = Uint8Array.from(atob(file.content), (c) =>
        c.charCodeAt(0)
      );
      saveAs(new Blob([bytes], { type: "application/pdf" }), file.file_name);
    });

    const markInvoiced = (list) =>
      list.map((b) =>
        invoices[b.booking_id] ? { ...b, invoice: invoices[b.booking_id] } : b
      );
    setBookings(markInvoiced);
    setFilteredBookings(markInvoiced);

    if (failed) {
      toast.warning(`${failed} invoice(s) could not be generated`);
    }
  };

  const handleInvoiceDownload = async (booking) => {
    setInvoiceLoadingId(booking.booking_id);
    try {
      await downloadInvoices([booking.booking_id]);
    } catch (error) {
      handleError(error);
    } finally {
      setInvoiceLoadingId(null);
    }
  };

  const handleBulkInvoiceDownload = async () => {
    if (!selectedInvoiceIds.length) {
      toast.warning("Please select at least one booking");
      return;
    }
    setBulkInvoiceLoading(true);
    try {
      await downloadInvoices(selectedInvoiceIds);
      setSelectedInvoiceIds([]);
    } catch (error) {
      handleError(error);
    } finally {
      setBulkInvoiceLoading(false);
    }
  };

  const handleDetails = (index) => {
    const booking = sortedBookings[index];
    // Opens in a new tab instead of navigating away, so this list's filters/
    // search/scroll position are never lost - there's no "coming back" to
    // reset, this tab never leaves the list. BookingsDetails.jsx already
    // falls back to the URL param when there's no router state to read
    // (a fresh tab has none), so it resolves the booking correctly either way.
    window.open(`/bookingDetails/${booking.booking_id}`, "_blank");
  };

  const handleSearch = useCallback(() => {
    const dataToSearch = filterApplied ? filteredBookings : bookings;
    const searchFiltered = dataToSearch.filter((booking) =>
      Object.values(booking).some((value) =>
        value
          ?.toString()
          .toLowerCase()
          .includes(searchTerm.trim().toLowerCase())
      )
    );
    setFilteredBookings(searchFiltered);
  }, [searchTerm, bookings, filteredBookings, filterApplied]);

  const toggleFilters = () => {
    setShowFilters(!showFilters || filterApplied);
  };

  useEffect(() => {
    fetchBookings(startDate, endDate);
    fetchFilters();
    handleFilter();
  }, [fetchFilters]);

  useEffect(() => {
    if (triggerFilterOnClear) {
      handleFilter();
      setTriggerFilterOnClear(false);
    }
    if (filterApplied || searchTerm) {
      applyFilters();
    }
  }, [
    filterApplied,
    searchTerm,
    bookings,
    startDate,
    endDate,
    triggerFilterOnClear
  ]);
  console.log(filteredBookings, sortedBookings, "filteredBookings");
  const bookingsData = sortedBookings.map((booking) => [
    booking.vendor_id || booking.vendor_name ? (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px"
        }}
      >
        <input
          type="checkbox"
          checked={selectedBookings.some(
            (b) => b.booking_id === booking.booking_id
          )}
          onChange={() => handleCheckboxChange(booking)}
        />

        {booking?.booking_mode === "EZP" ? (
          <span
            style={{
              color: "green",
              fontWeight: "600",
              fontSize: "13px",
              display: "flex",
              alignItems: "center",
              gap: "4px"
            }}
          >
            <FaCheckCircle />
            Synced from EZP
          </span>
        ) : Number(booking?.is_synced) === 1 ? (
          <span
            style={{
              color: "green",
              fontWeight: "600",
              fontSize: "13px",
              display: "flex",
              alignItems: "center",
              gap: "4px"
            }}
          >
            <FaCheckCircle />
            Synced
          </span>
        ) : null}
      </div>
    ) : null,

    booking.invoice ? (
      <button
        type="button"
        className="btn btn-sm btn-outline-secondary d-flex align-items-center gap-1"
        onClick={() => handleInvoiceDownload(booking)}
        disabled={invoiceLoadingId === booking.booking_id}
        title="Download invoice"
      >
        <FaFilePdf style={{ color: "#d01c4c" }} />
        {invoiceLoadingId === booking.booking_id ? "Preparing..." : "Download"}
      </button>
    ) : booking.status_id === 5 ? (
      <input
        type="checkbox"
        title="Select to generate invoice"
        checked={selectedInvoiceIds.includes(booking.booking_id)}
        onChange={() => toggleInvoiceSelection(booking.booking_id)}
      />
    ) : (
      "-"
    ),

    booking.display_booking_id,
    "Online",
    booking.first_name,
    booking.last_name,
    booking.phone_number,
    booking.service_name,
    booking.service_type_name,
    booking.service_offering_name,
    new Date(booking.serviceDate).toLocaleDateString(),
    normalizeTimeTo24Hour(booking.service_time),
    booking.serviceAmount,
    booking.payment,
    booking.vendor_name || "-",
    booking.status,
    booking.service_details?.service_state
      ? booking.service_details?.service_state
      : booking.service_details?.to_state
  ]);

  const handleFilter = async () => {
    if (!startDate || !endDate) {
      alert("Please select both start and end dates");
      return;
    }
    const body = {
      startDate: startDate,
      endDate: endDate
    };
    try {
      const response = await apicall.post(body, "orders_info");
      // console.log('Filtered bookings:', response.data);
      setOrderInfo(response.data[0]);
      // console.log(body.startDate, "body.startDate")
      fetchBookings(body.startDate, body.endDate);
    } catch (error) {
      console.error("Error fetching filtered bookings:", error);
    }
  };
  // const handleCardClick = async (statusArray) => {
  //   try {
  //     const body = {
  //       startDate: startDate,
  //       endDate: endDate,
  //       status: statusArray
  //     };

  //     const response = await apicall.post(body, 'DateFilter');

  //     const updatedBookings = await Promise.all(
  //       response.data.map(async (booking) => {
  //         const isSynced = await checkEzpSyncStatus(booking.booking_id);

  //         return {
  //           ...booking,
  //           is_synced: isSynced
  //         };
  //       })
  //     );

  //     const filtered = updatedBookings.filter((booking) =>
  //       allowedStatuses.includes(booking.status)
  //     );

  //     setFilteredBookings(filtered);

  //   } catch (error) {
  //     console.error("Error fetching filtered bookings:", error);
  //   }
  // };

  const handleCardClick = async (statusArray) => {
    try {
      const body = {
        startDate: startDate,
        endDate: endDate,
        status: statusArray
      };

      const response = await apicall.post(body, "DateFilter");

      const filtered = response.data.filter((booking) =>
        allowedStatuses.includes(booking.status)
      );

      setFilteredBookings(filtered);
    } catch (error) {
      console.error("Error fetching filtered bookings:", error);
    }
  };
  useEffect(() => {
    if (!sortDirection || !sortColumn) {
      setSortedBookings(filteredBookings);
      return;
    }

    const columnKeyMap = {
      display_booking_id: "display_booking_id",
      first_name: "first_name",
      service_date: "serviceDate",
      vendor_name: "vendor_name"
    };

    const key = columnKeyMap[sortColumn];
    if (!key) return;

    const normalizeVendor = (val) =>
      val && val !== "-" ? val.toString().toLowerCase() : null;

    const sorted = [...filteredBookings].sort((a, b) => {
      const aVal = a[key];
      const bVal = b[key];

      // ✅ Vendor Name special handling
      if (sortColumn === "vendor_name") {
        const aNorm = normalizeVendor(aVal);
        const bNorm = normalizeVendor(bVal);

        // Always push empty / '-' to bottom
        if (aNorm === null && bNorm === null) return 0;
        if (aNorm === null) return 1;
        if (bNorm === null) return -1;

        return sortDirection === "asc"
          ? aNorm.localeCompare(bNorm)
          : bNorm.localeCompare(aNorm);
      }

      // ✅ Service date sorting
      if (sortColumn === "service_date") {
        const aDate = new Date(aVal);
        const bDate = new Date(bVal);
        return sortDirection === "asc" ? aDate - bDate : bDate - aDate;
      }

      // ✅ Numeric sorting fallback
      const aNum = Number(aVal);
      const bNum = Number(bVal);
      if (!isNaN(aNum) && !isNaN(bNum)) {
        return sortDirection === "asc" ? aNum - bNum : bNum - aNum;
      }

      // ✅ Default string sorting
      return sortDirection === "asc"
        ? aVal?.toString().localeCompare(bVal?.toString())
        : bVal?.toString().localeCompare(aVal?.toString());
    });

    setSortedBookings(sorted);
  }, [sortDirection, sortColumn, filteredBookings]);

  const renderSortableHeader = (label, columnKey) => (
    <div
      onClick={() => handleSort(columnKey)}
      style={{
        cursor: "pointer",
        userSelect: "none",
        display: "inline-flex",
        alignItems: "center",
        gap: "4px"
      }}
      aria-label={`Sort by ${label}`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          handleSort(columnKey);
        }
      }}
    >
      {label}
      <span
        style={{ display: "flex", flexDirection: "column", lineHeight: "10px" }}
      >
        <FaSortUp
          color={
            sortColumn === columnKey && sortDirection === "asc"
              ? "#000"
              : "#000"
          }
          size={14}
        />
        <FaSortDown
          color={
            sortColumn === columnKey && sortDirection === "desc"
              ? "#000"
              : "#000"
          }
          size={14}
        />
      </span>
    </div>
  );

  const bookingHeaders = [
    "Sync Status",
    "Invoice",
    renderSortableHeader("Booking ID", "display_booking_id"),
    "Mode",
    renderSortableHeader("First Name", "first_name"),
    "last_name",
    "phone_number",
    "Service Name",
    "service_type_name",
    "service_offering_name",
    renderSortableHeader("Service Date", "service_date"),
    "service_time",
    "ServiceAmount",
    "Payment status",
    renderSortableHeader("Vendor Name", "vendor_name"),
    "Service Status",
    "Service Emirate/City"
  ];

  return (
    <div className="container mt-3">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3>Bookings</h3>
          <p className="content mb-3">Here is a list of all Bookings</p>
        </div>

        <div className="mx-5 mb-4">
          <InputGroup>
            <Form.Control
              type="search"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={{ width: "350px" }}
            />
            <InputGroup.Text
              className="primaryBackground"
              onClick={handleSearch}
            >
              <FaSearch className="text-white" />
            </InputGroup.Text>
          </InputGroup>
        </div>
        <div className="d-flex align-items-center mb-3">
          <img
            className="mx-2"
            src="/image/filter_active_icon.png"
            alt="Filter Applied"
            style={{
              display: filterApplied ? "block" : "none",
              cursor: "pointer"
            }}
            onClick={toggleFilters}
          />
          <img
            className="mx-2"
            src="/image/filter_iocn.png"
            alt="Filter"
            style={{
              display: filterApplied ? "none" : "block",
              cursor: "pointer"
            }}
            onClick={toggleFilters}
          />

          {/* {role == 1 && */}
          <button
            className="btn Button primaryBackground text-white"
            onClick={() => navigate("/orderdetails")}
          >
            Add Order
          </button>
          {/* } */}
        </div>
      </div>
      <div className="order-info-section">
        <div className="cards-row" aria-label="Order Information Cards">
          <div
            className="custom-card"
            onClick={() => handleCardClick([2, 3, 4, 5, 6, 7, 9])}
            style={{ cursor: "pointer" }}
          >
            <p>Total Confirmed Orders</p>
            <h4>{oderInfo?.total_confirmed}</h4>
          </div>
          <div
            className="custom-card"
            onClick={() => handleCardClick([2])}
            style={{ cursor: "pointer" }}
          >
            <p>Not Assigned</p>
            <h4>{oderInfo?.not_assigned}</h4>
          </div>
          <div
            className="custom-card"
            onClick={() => handleCardClick([2, 3, 4, 9])}
            style={{ cursor: "pointer" }}
          >
            <p>In Progress</p>
            <h4>{oderInfo?.in_progress}</h4>
          </div>
          <div
            className="custom-card"
            onClick={() => handleCardClick([5])}
            style={{ cursor: "pointer" }}
          >
            <p>Completed</p>
            <h4>{oderInfo?.completed}</h4>
          </div>
          <div
            className="custom-card"
            onClick={() => handleCardClick([6, 7, 8])}
            style={{ cursor: "pointer" }}
          >
            <p>Cancelled</p>
            <h4>{oderInfo?.cancelled}</h4>
          </div>
        </div>
      </div>
      <div className="d-flex gap-3 mb-4 align-items-end w-100 flex-wrap">
        {/* Left side: Filters and Apply button */}
        <div className="d-flex gap-3 flex-wrap align-items-end">
          <div>
            <label htmlFor="startDate" className="form-label">
              Start Date
            </label>
            <input
              type="date"
              id="startDate"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              className="form-control"
            />
          </div>

          <div>
            <label htmlFor="endDate" className="form-label">
              End Date
            </label>
            <input
              type="date"
              id="endDate"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              className="form-control"
            />
          </div>

          {/* Apply button stays on the left */}
          <button
            className="btn"
            onClick={handleFilter}
            style={{
              background: "#d01c4c",
              minWidth: "80px",
              height: "40px",
              marginTop: "30px",
              color: "white"
            }}
          >
            Apply
          </button>
        </div>

        <div className="d-flex gap-2 ms-auto mt-3">
          <button
            className="btn Button text-black primaryColorText btn-outline-secondary"
            onClick={clearAll}
            style={{ height: "40px" }}
          >
            Clear All
          </button>

          <button
            className="btn Button text-black primaryColorText btn-outline-secondary"
            style={{ height: "40px" }}
            onClick={exportToExcel}
          >
            <FaFileExcel style={{ color: "green" }} className="me-2" />
            Export
          </button>
          <button
            className="btn Button primaryBackground text-white sync-btn"
            onClick={handleSync}
            disabled={selectedBookings.length === 0}
          >
            Sync
          </button>
          <button
            className="btn Button text-black primaryColorText btn-outline-secondary d-flex align-items-center"
            style={{ height: "40px" }}
            onClick={handleBulkInvoiceDownload}
            disabled={!selectedInvoiceIds.length || bulkInvoiceLoading}
          >
            <FaFilePdf style={{ color: "#d01c4c" }} className="me-2" />
            {bulkInvoiceLoading
              ? "Preparing..."
              : `Download Invoice${
                  selectedInvoiceIds.length
                    ? ` (${selectedInvoiceIds.length})`
                    : ""
                }`}
          </button>
        </div>
      </div>
      {showFilters && (
        <div className="filter-container mb-3">
          {/* FILTER FIELDS */}
          <div className="filter-fields">
            <div className="multi-filter">
              <MultiSelect
                value={serviceFilter}
                options={services}
                onChange={(e) => setServiceFilter(e.value)}
                optionLabel="name"
                placeholder="Select Services"
                filter
                maxSelectedLabels={2}
                className="w-100"
              />
            </div>
            <div className="multi-filter">
              <MultiSelect
                value={statusFilter}
                options={statusList}
                onChange={(e) => setStatusFilter(e.value)}
                optionLabel="name"
                placeholder="Select Status"
                filter
                maxSelectedLabels={2}
                className="w-100"
              />
            </div>

            <div className="multi-filter">
              <MultiSelect
                value={paymentStatusFilter}
                options={fallbackStatusList}
                onChange={(e) => setPaymentStatusFilter(e.value)}
                optionLabel="name"
                placeholder="Payment Status"
                filter
                maxSelectedLabels={2}
                className="w-100"
              />
            </div>

            {/* DATE PICKER */}
            <div className="date-filter">
              <DatePicker
                selected={dateFilter}
                onChange={(date) => {
                  setDateFilter(date);
                  setShowDatePicker(false);
                }}
                open={showDatePicker}
                onInputClick={() => setShowDatePicker(true)}
                onClickOutside={() => setShowDatePicker(false)}
                portalId="datepicker-portal"
                popperPlacement="bottom-start"
                customInput={
                  <button
                    type="button"
                    className="btn btn-outline-secondary w-100"
                  >
                    {dateFilter
                      ? new Date(dateFilter).toLocaleDateString()
                      : "Select Booking Date"}
                  </button>
                }
              />
            </div>

            {/* MULTISELECTS */}
            <div className="multi-filter">
              <MultiSelect
                value={vendorFilter}
                options={vendors}
                onChange={(e) => setVendorFilter(e.value)}
                optionLabel="vendor_name"
                placeholder="Select Vendors"
                filter
                maxSelectedLabels={2}
                className="w-100"
              />
            </div>

            <div className="multi-filter">
              <MultiSelect
                value={stateFilter}
                options={operatingStateOptions}
                onChange={(e) => setStateFilter(e.value)}
                optionLabel="name"
                placeholder="Select State/Emirate"
                filter
                maxSelectedLabels={2}
                className="w-100"
              />
            </div>

            <div className="multi-filter">
              <MultiSelect
                value={cityFilter}
                options={operatingCityOptions}
                onChange={(e) => setCityFilter(e.value)}
                optionLabel="name"
                placeholder="Select City"
                filter
                maxSelectedLabels={2}
                className="w-100"
              />
            </div>

            {/* ACTION BUTTONS */}
            <div className="filter-actions">
              <button
                className="btn Button primaryBackground text-white"
                onClick={applyFilters}
              >
                Apply
              </button>

              <button
                className="btn Button text-black primaryColorText btn-outline-secondary no-hover-effect"
                onClick={clearAllFilters}
              >
                Clear All
              </button>
            </div>
          </div>
        </div>
      )}

      {loadingBookings ? (
        <Skeleton count={5} height={40} />
      ) : (
        <div className="bookings-table">
          <Table
            headers={bookingHeaders}
            data={bookingsData}
            pagination={true}
            recordsCount={10}
            details={handleDetails}
            detailsAtStart={true}
          />
        </div>
      )}
    </div>
  );
};

export default BookingsList;
